import React from "react";
import Canvas from "../../../components/Canvas";

const HeroSection = ({ job }) => {
  return (
    <section className="page-hero">
      <Canvas />
      <div className="container page-hero-grid">
        <div>
          <p className="eyebrow">Open role</p>
          <h1>{job.title}</h1>
          <p className="hero-copy">{job.summary}</p>
          <div className="actions">
            <a className="button button-primary button-md" href="#application">
              Apply Now
            </a>
            <a
              className="button button-secondary button-md"
              href="/careers"
              data-discover="true"
            >
              Back to Careers
            </a>
          </div>
        </div>
        <div className="page-hero-media">
          <section className="card role-snapshot-card">
            <p className="eyebrow">Role Snapshot</p>
            <dl>
              <div>
                <dt>Location</dt>
                <dd>{job.location}</dd>
              </div>
              <div>
                <dt>Employment</dt>
                <dd>{job.employmentType}</dd>
              </div>
              <div>
                <dt>Department</dt>
                <dd>{job.department}</dd>
              </div>
            </dl>
          </section>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
